import { actionTypes } from '../../types';

// Action request
export const searchBusinessPlaceForAgency = (payload, callback) => ({
    type: actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_REQUEST,
    payload,
    callback
});

// Action success
export const searchBusinessPlaceForAgencySuccess = (payload) => ({
    type: actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_SUCCESS,
    payload,
});

// Action failure
export const searchBusinessPlaceForAgencyFailure = (payload) => ({
    type: actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_FAILURE,
    payload,
});

// Action reset status
export const searchBusinessPlaceForAgencyReset = () => ({
    type: actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET,
});

// Action reset all reducer
export const searchBusinessPlaceForAgencyResetAll = () => ({
    type: actionTypes.SEARCH_BUSINESS_PLACE_FOR_AGENCY_RESET_ALL,
});
